var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"js-timeline-component"},_vm._l((_vm.visibleSteps),function(step,name){return _c(_vm.stepComponentName(name),{key:name,ref:`step-${step.id}`,refInFor:true,tag:"component",attrs:{"step":step}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }